module.exports = __webpack_public_path__ + "static/media/CTLA_4-286w.61c94c79.jpg";